<div class="bedrocc-tab-group theme-{{ block.data.theme }}">
    <core-tab-group breakpointSize="medium">
        @for (action of block.content; track action.id) {
            <core-tab-item [header]="action.data.title">
                @for (tabItem of action.content; track tabItem.id) {
                    <ng-container>
                        @for (subBlock of tabItem.content; track subBlock.id) {
                            <core-block [block]="subBlock"></core-block>
                        }
                    </ng-container>
                }
            </core-tab-item>
        }
    </core-tab-group>
</div>
